import React, { useEffect } from 'react';
import { ModuleTitle } from '../utilities/ModuleTitle.tsx';


export const BallPythonCare = ({ setChapters, backToMenu }) => {
    useEffect(() => {
        setChapters(
            ['Housing', 'Heating', 'Substrate', 'Hides', 'Shedding', 'Feeding', 'Cleaning']
        )
    }, [])

    return (
        <React.Fragment>
            <ModuleTitle title="Ball Python Care" backToMenu={backToMenu} />

            <div id="Housing" className="care-sheet-para">
                <h2>Housing</h2>

                <p>
                    As with all snakes, Ball Pythons are great at escaping. Therefore, when caging your new pet you should make sure there aren't
                    any holes where they can get through. Snakes are able to flatten themselves to squeeze through many tight
                    spaces. The most cost effective way to keep a Ball Python as pets is to purchase a 15-20 gallon tank, as a
                    10 gallon tank will be too small for an adult Ball Python but it is fine for a hatchling to young juvenile
                    snake. Be sure that whatever choice you make for caging that there are venting areas in the tank to ensure
                    good airflow, and avoiding stagnant air. Snakes are NOT communal animals! It is not recommended to keep 2
                    or more snakes in the same cage (especially young ones) for an extended period of time. Ball Pythons may
                    eat eachother and as a result both may die in the process. Because snakes refer to their sense of smell the
                    most when it comes to deciding what is food or not, this is what is believed to cause this canabalism. While
                    it is possible to keep Ball Pythons together granted that they are above 30" you may have issues with the
                    snakes being stressed out.
                </p>
            </div>
            <div id="Heating" className="care-sheet-para">
                <h2>Heating</h2>
                <p>

                    Ball Pythons are instinctively nocturnal. That being said the best way to keep a Ball Python healthy is through undertank
                    heating. Undertank heating is done through a adhesive pad that sticks to the bottom of the tank and plugs
                    into an electrical socket. These pads are set to only reach a certain temperature, and can be left on continuously
                    because the snake will move around where the temperature is comfortable for them. The pad should be placed
                    on one end of the tank and only cover 1/4 to 1/3 of the tank's bottom to create a heat gradient so the snake
                    can regulate it's body temperature. Although they are nocturnal they should have day/night cycles, this can
                    be easily be achieved by being in a room with a window allowing mother nature to take care of it. If doesn't
                    have windows you can simply leave a light on in the room during the day and turn it off at night. The ideal
                    temperature range for Ball Pythons is 80-85 F on the hot side. Just keep in mind that when using undertank
                    heating, the temperature to check is on the ground and not the air. The ground temperature may achieve higher
                    than the recommended levels, but Ball Pythons won't burn themselves if the heating pad is only on one side.

                </p>
            </div>
            <div id="Substrate" className="care-sheet-para">
                <h2>Substrate</h2>
                <p>
                    The choice of substrate is really a matter of personal preference. However, cedar and bark should not be used! Cedar is known
                    to be toxic to snakes and can cause illness/death as a result. Sand and gravel should also be avoided due
                    to the low absorbancy and increase in harmful bacteria growth, as well as being dangerous to the snake if
                    ingested. Aspen bedding is the most popular choice for snake keepers as it is aesthetically pleasing, has
                    a non-offensive smell and is quite absorbant. A cheaper alternative is to use newspaper sheets or paper towels,
                    however the ink on the newspaper will transfer to the snake and temporarily make them appear darker due to
                    the ink coating.
                </p>

            </div>

            <div id="Hides" className="care-sheet-para">
                <h2>Hides / Water (tank set up)</h2>
                <p>
                    Ball Pythons do occasionally climb but they will often be found on the bottom of the enclosure. That in mind there should
                    be atleast 2 places to hide for your pet, one for the hot side and one for the cool side. Feel free to add
                    any additional hides after that. A hide can consist of anything from a plastic container turned upside down,
                    to a more aesthetic hide that you can find at pet stores. Be sure that the hide allows for the snake to be
                    completley covered and is not see through, otherwise the snake will become stressed. As for water, a bowl
                    that is large enough for your snake to completely lie inside of it. This will also help for shedding skin
                    when the time comes. Not only is a large bowl recommended it is also requires less maintenance because it
                    will retain the water much longer than a smaller one.
                </p>
            </div>
            <div id="Shedding" className="care-sheet-para">
                <h2> Shedding</h2>
                <p>
                    Shedding is an important process for reptiles, at this time the snake's entire outer skin becomes loose and eventually falls
                    off. The outer layer of the snake's eyes will also come off giving them a "blue" color, this is where the
                    term in the "blue" comes from. It is referring to the color of the eyes when the snake begins shedding. In
                    most cases, Ball Pythons don't require much humidity during this time, but it doesn't hurt to spray the tank
                    a little to help.
                </p>
            </div>
            <div id="Feeding" className="care-sheet-para">
                <h2>Feeding</h2>
                <p>
                    Feeding your Ball Python is a very simple process, and only needs to be done once a week. In the wild, Ball Pythons eat a
                    variety of different prey items including insects, lizards, and rodents. In captivity, Ball Pythons only
                    need to eat rats or mice. Whether you choose to feed your pet rats or mice it is important that they are
                    captive kept. Feeding your snake wild caught prey increases the likelihood that your snake will get parasites
                    or become ill and can lead to death. Rodents can be fed to your snake either alive or frozen. Feeding live
                    rodents runs the risk that the snake may be bit by the prey. Not only that but keeping live rodents will
                    smell bad. Frozen prey allows you to buy in bulk and is the cheapest/easiest way to keep the food. Be sure
                    to heat up the frozen mice until they are warm, very similar to a regular mouse's body heat. If the prey
                    is too hot or too cold the snake will probably not eat it. Size of the prey is also an important factor,
                    the general rule of thumb is to select mice/rats that are no wider than 2 times the width of the snake's
                    widest body section, 1.5 times is recommended maximum size however. While you can feed the snake inside it's
                    cage, as a pet you may want to feed it in a seperate container or cardboard box. Otherwise, the snake may
                    confuse your hands/fingers as it's prey and bite you instead. Feeding them outside the enclosure, trains
                    the snake to recognize when it is feeding time or not based on it's surroundings.

                </p>
            </div>

            <div id="Cleaning" className="care-sheet-para">
                <h2>Cleaning</h2>
                <p>Cleaning should be done atleast every 2 months. Dirty cages are breeding grounds for unwanted bacteria, parasites
                    and bugs. Make sure to remove all poop you find and wash the hides with soap.</p>
            </div>

        </React.Fragment >
    )
}

export const CornSnakeCare = ({ setChapters, backToMenu }) => {
    useEffect(() => {
        setChapters(
            ['Introduction', 'Housing', 'Heating', 'Substrate', 'Hides', 'Shedding', 'Feeding', 'Cleaning']
        )
    }, [])

    return (
        <React.Fragment>
            <ModuleTitle title="Corn Snake Care" backToMenu={backToMenu} />
            <div id="Introduction" className="care-sheet-para">
                <h2>Introduction</h2>
                <p> Corn Snakes (Red Rat Snakes) are one of the easiest pet snakes to care for. Their care requirements are very minimal and they only grow up to 6ft max, however most will only reach 3.5 to 4.5 ft. This size as well as their temperament makes them a popular first snake for new reptile owners. The odd common name "Corn Snake" originates all the way back to 1675 because these snakes were commonly found in their grain/corn storage hunting the rats and mice there. Some believe that the name comes from the "checker board" pattern on their belly, resembling corn kernels.
                    Corn snakes are non-venomous and actually benefitial to humans, they eat the rodents that may be found eating our plants. Despite their benefitial nature, they are often mistaken for copperhead snakes and as a result are killed.
                </p>
            </div>
            <div id="Housing" className="care-sheet-para">
                <h2>Housing</h2>
                <p>
                    As with all snakes, corn snakes are great at escaping. Therefore, when caging your new pet you should make sure there aren't any holes where they can get through. Snakes are able to flatten themselves to squeeze through many tight spaces.
                    The most cost effective way to keep a cornsnake as pets is to purchase a 15-20 gallon tank, as a 10 gallon tank will be too small for an adult cornsnake but it is fine for a hatchling to young juvenile snake. Be sure that whatever choice you make for caging that there are venting areas in the tank to ensure good airflow, and avoiding stagnant air.
                    Snakes are NOT communal animals! It is not recommended to keep 2 or more snakes in the same cage (especially young ones) for an extended period of time. Corn snakes may eat eachother and as a result both may die in the process. Because snakes refer to their sense of smell the most when it comes to deciding what is food or not, this is what is believed to cause this canabalism. While it is possible to keep corn snakes together granted that they are above 30" you may have issues with the snakes being stressed out.
                </p>
            </div>
            <div id="Heating" className="care-sheet-para">
                <h2>Heating</h2>
                <p>
                    Corn snakes are instinctively nocturnal. That being said the best way to keep a corn snake healthy is through undertank heating. Undertank heating is done through a adhesive pad that sticks to the bottom of the tank and plugs into an electrical socket. These pads are set to only reach a certain temperature, and can be left on continuously because the snake will move around where the temperature is comfortable for them. The pad should be placed on one end of the tank and only cover 1/4 to 1/3 of the tank's bottom to create a heat gradient so the snake can regulate it's body temperature. Although they are nocturnal they should have day/night cycles, this can be easily be achieved by being in a room with a window allowing mother nature to take care of it. If doesn't have windows you can simply leave a light on in the room during the day and turn it off at night.
                    The ideal temperature range for corn snakes is 80-85 F on the hot side. Just keep in mind that when using undertank heating, the temperature to check is on the ground and not the air. The ground temperature may achieve higher than the recommended levels, but corn snakes won't burn themselves if the heating pad is only on one side.
                </p>
            </div>
            <div id="Substrate" className="care-sheet-para">
                <h2>Substrate</h2>
                <p>
                    The choice of substrate is really a matter of personal preference. However, cedar and bark should not be used! Cedar is known to be toxic to snakes and can cause illness/death as a result. Sand and gravel should also be avoided due to the low absorbancy and increase in harmful bacteria growth, as well as being dangerous to the snake if ingested. Aspen bedding is the most popular choice for snake keepers as it is aesthetically pleasing, has a non-offensive smell and is quite absorbant. A cheaper alternative is to use newspaper sheets or paper towels, however the ink on the newspaper will transfer to the snake and temporarily make them appear darker due to the ink coating.
                </p>

            </div>

            <div id="Hides" className="care-sheet-para">
                <h2>Hides / Water (tank set up)</h2>
                <p>
                    Corn snakes do occasionally climb but they will often be found on the bottom of the enclosure. That in mind there should be atleast 2 places to hide for your pet, one for the hot side and one for the cool side. Feel free to add any additional hides after that. A hide can consist of anything from a plastic container turned upside down, to a more aesthetic hide that you can find at pet stores. Be sure that the hide allows for the snake to be completley covered and is not see through, otherwise the snake will become stressed. As for water, a bowl that is large enough for your snake to completely lie inside of it. This will also help for shedding skin when the time comes. Not only is a large bowl recommended it is also requires less maintenance because it will retain the water much longer than a smaller one.
                </p>
            </div>
            <div id="Shedding" className="care-sheet-para">
                <h2> Shedding</h2>
                <p>
                    Shedding is an important process for reptiles, at this time the snake's entire outer skin becomes loose and eventually falls off. The outer layer of the snake's eyes will also come off giving them a "blue" color, this is where the term in the "blue" comes from. It is referring to the color of the eyes when the snake begins shedding. In most cases, corn snakes don't require much humidity during this time, but it doesn't hurt to spray the tank a little to help.
                </p>
            </div>
            <div id="Feeding" className="care-sheet-para">
                <h2>Feeding</h2>
                <p>
                    Feeding your corn snake is a very simple process, and only needs to be done once a week. In the wild, corn snakes eat a variety of different prey items including insects, lizards, and rodents. In captivity, corn snakes only need to eat rats or mice. Whether you choose to feed your pet rats or mice it is important that they are captive kept. Feeding your snake wild caught prey increases the likelihood that your snake will get parasites or become ill and can lead to death.
                    Rodents can be fed to your snake either alive or frozen. Feeding live rodents runs the risk that the snake may be bit by the prey. Not only that but keeping live rodents will smell bad. Frozen prey allows you to buy in bulk and is the cheapest/easiest way to keep the food. Be sure to heat up the frozen mice until they are warm, very similar to a regular mouse's body heat. If the prey is too hot or too cold the snake will probably not eat it. Size of the prey is also an important factor, the general rule of thumb is to select mice/rats that are no wider than 2 times the width of the snake's widest body section, 1.5 times is recommended maximum size however.
                    While you can feed the snake inside it's cage, as a pet you may want to feed it in a seperate container or cardboard box. Otherwise, the snake may confuse your hands/fingers as it's prey and bite you instead. Feeding them outside the enclosure, trains the snake to recognize when it is feeding time or not based on it's surroundings.
                </p>
            </div>
            <div id="Cleaning" className="care-sheet-para">
                <h2>Cleaning</h2>
                <p>Cleaning should be done atleast every 2 months. Dirty cages are breeding grounds for unwanted bacteria, parasites and bugs. Make sure to remove all poop you find and wash the hides with soap.</p>
            </div>
        </React.Fragment >
    )
}
export const LeopardGeckoCare = ({ setChapters, backToMenu }) => {
    useEffect(() => {
        setChapters(
            ['Introduction', 'Housing', 'Heating', 'Substrate', 'Hides', 'Shedding', 'Feeding', 'Cleaning']
        )
    }, [])

    return (
        <React.Fragment>
            <ModuleTitle title="Leopard Gecko Care" backToMenu={backToMenu} />
            <div id="Introduction" className="care-sheet-para">
                <h2>Introduction</h2>
                <p>Leopard Geckos are one of the easiest reptiles to care for in the trade today, they are also one of the
                    most
                    genetically diverse reptiles these days. Not only are they easy to care for but they are also very
                    passive
                    creatures that are simple to breed. These reptiles get their name from the immense amounts of black
                    spots
                    covering their bodies and tails, on top of that they also have a light yellow color on their heads and
                    bodies.
                    The tail of a leopard gecko is a pale blue / white color with the famous spots they are known for. Today
                    leopard geckos can come in many different colors, sizes and patterns.
                </p>
            </div>
            <div id="Housing" className="care-sheet-para">
                <h2>Housing</h2>

                <p>Leopard Geckos don't require much space to be happy. A regular 10 gallon fish tank will be plenty for the
                    full
                    lifecycle of a leopard gecko. However, feel free to upgrade your gecko's tank to bigger sizes if you
                    want
                    to give them more space or more decorate. Keep in mind, that despite being classified as geckos, Leopard
                    Geckos lack the ability to stick to walls and they are actually poor climbers. As such when picking a
                    larger
                    size tank try to stick to aquariums with more surface area on the bottom to give them the most space.
                    Although
                    they are poor climebers they are quite curious creatures that may make attempts to climb on top of their
                    surroundings. A lid for your tank is recommended but not required as they won't be able to climb out
                    without
                    assistance, the screen is merely a preventative measure to keep unwanted insects/animals/children from
                    harming
                    your pet. Multiple geckos can be kept together, but they would prefer to be alone they won't get
                    "lonely".
                    For multiple geckos, be sure to get an adequately sized tank, 10 gallon can house 2 just fine and a 20
                    or
                    30 gallon long tank should be fine for 3-4 geckos. If you wish to introduce an additional gecko to an
                    existing
                    setup make sure to thoroughly wash out all the hides/bowls and replace the substrate because these
                    reptiles
                    are territorial and not doing so may lead to fighting. Never keep 2 males together, as hatchlings and
                    young
                    juveniles 2 males together may be fine but there will come a time where they will start wanting to
                    establish
                    territory and fight one another. Females may also fight eachother despite washing out everything in the
                    tank
                    so keep a close eye on them throughout the day to make sure they are behaving so no injuries occur.
                </p>
            </div>
            <div id="Heating" className="care-sheet-para">
                <h2>Heating</h2>
                <p>Contrary to popular belief, not all reptiles require a heat lamp. Keep in mind Leopard Geckos are
                    nocturnal by
                    nature and light may actually stress them out. In the wild these creatures will hide in dark places
                    during
                    the day and search for food in the night. Any breeder will tell you that under the tank heating is the
                    best
                    way to keep your leopard gecko warm and happy. The under the tank heater is typically just a black mat
                    with
                    adhesive on one side to stick underneath the tank, to create a much needed heat gradient the pad should
                    be
                    underneath one of the far ends of the enclosure so that if the gecko gets too hot they can move to the
                    opposite
                    side of the tank to maintain a proper body heat. Contrary to popular belief, coldblooded animals can get
                    overheated, so this heat gradient is absolutely necessary. The hot side of the tank should only reach 90
                    degrees, keep in mind that the undertank heater won't heat up the air around it too much so a regular
                    thermometer
                    won't reflect the temperature of the heat source. Many breeders will advise you not to use heat rocks as
                    a heat source, they are infamous for malfunctioning and overheating to the point where the reptiles will
                    suffer severe burns. If the proper heat isn't achieved on the hot side a heat lamp can be used, it is
                    recommended
                    that a red bulb is used for leopard geckos as reptiles have a hard time seeing red light so it shouldn't
                    stress them out. The cool side of the tank should be roughly 80 degrees F but this isn't too important
                    as
                    long as this side doesn't get much hotter than that. Reptiles are smart enough to avoid places that will
                    be too cold so less than 80 degrees shouldn't be a problem.
                </p>
            </div>
            <div id="Substrate" className="care-sheet-para">
                <h2>Substrate</h2>
                <p>Picking substrate (the ground material) for leopard geckos is a fairly crucial step to success in leopard
                    gecko
                    keeping as picking the wrong substrate can lead to severe health problems. Sand isn't recommended the
                    problem
                    with sand or vita-sand is that the gecko is highly likely to eat this sand accidentally. Eating sand
                    usually
                    occurs when the gecko misses it's prey and bites the sand or the food already being coated in sand. When
                    the gecko eats sand, it will cause a condition called "impaction" this is when the sand clumps together
                    in
                    the stomach/intestines and fills up the stomach often leading to not eating enough and in many cases
                    death!
                    Most large scale breeders use paper towels as their substrate and a keeper can do that too. If paper
                    towels
                    isn't aesthetically pleasing to you, you can also buy something called Repticarpet. Repticarpet is
                    exaclty
                    what you might think, it is a sheet of colored fiber and is easily washed and cleaned. </p>

            </div>

            <div id="Hides" className="care-sheet-para">
                <h2>Hides / Water (tank set up)</h2>
                <p> In the wild, Leopard Geckos will hide most of the day under a rock or under debris. It is important to
                    have atleast
                    2 hides in a tank, one for the hot side near the heat source and one for the colder side. You can use
                    just
                    about anything as a hide as long as the gecko can hide underneath or inside it. Pet stores will offer
                    nice
                    elaborate decorations which are great, but breeders have great success using opaque plastic containers
                    or
                    foam trays with holes cut into them. Be sure to encorporate a clean bowl in your enclosure to hold water
                    for your pet. The bowl doesn't have to be huge but it does need to be large enough so that it always
                    contains
                    water for the gecko to drink.
                </p>
            </div>
            <div id="Shedding" className="care-sheet-para">
                <h2> Shedding</h2>
                <p> Many reptiles go through a process commonly known as shedding. In this process the older outer layer of
                    the reptiles
                    skin loosens up and eventually falls off. This process happens about once a month for adults but will
                    happen
                    about once a week or so for younger reptiles as they are growing quickly. When this process occurs it is
                    important to provide a moist hiding place so that the skin can come off much easier. A moist hide should
                    be made out of a material that won't grow mold when wet i.e. plastic, ceramic etc. the hide should
                    contain
                    something that can retain moisture such as sphagnum moss, coconut fiber, or even just paper towels, the
                    moist
                    hide as it suggests should be fairly wet to sopping wet during the shedding cycle and it can also be
                    kept
                    there even when the reptile is not shedding. Also during this time try to keep the humidity in the tank
                    a
                    little bit higher. Leopard Geckos will commonly pull their skin off by rubbing against their hides or by
                    pulling it off with their mouth or feet. Leopard Geckos also commonly eat their shed skin, this is a
                    perfectly
                    healthy practice. In the wild, leopard geckos avoid leaving any trace of themselves so that predators
                    will
                    have a harder time to find them. That is why Leopard geckos eat their shed skin and only defecate (poop)
                    in a single spot. Towards the end of the shedding stage keep note of any left over pieces of skin on or
                    around
                    the toes, these skin pieces can lead to constricting the reptile's toes and may even lead to losing the
                    toe
                    as a result. If there is left over shed on the toes you can, assist the gecko by soaking it in slightly
                    warm
                    water (not cold!) and even carefully pull the pieces off by hand.
                </p>
            </div>
            <div id="Food" className="care-sheet-para">
                <h2>Food</h2>
                <p> While leopard geckos have a fairly wide selection of diet choices there are a few choices to be made
                    when choosing
                    the diet for your animal. Leopard geckos will mainly only eat living prey, the movement will really draw
                    their attention. The most commonly used staple food for these reptiles are mealworms and crickets as
                    they
                    can contain all the nutrients neccessary for a healthy gecko. Which one to choose is really up to the
                    keeper/breeder.
                    While crickets move alot and draw more attention to the gecko as well as containing more of a
                    nutritional
                    benefit, they also can escape glass aquariums using the silicone sides. Not only can they escape, they
                    are
                    also known to bite the geckos if left in the tank too long. They are also very noisy and smell really
                    bad
                    if you choose to buy them in bulk (the cheaper way / easier way). Mealworms can't escape normal tanks
                    and
                    they can typically be contained in a high sided food dish. They can be left as a constant supply as food
                    as long as they stay in the dish and don't escape. Although crickets are better nutrition-wise,
                    mealworms
                    can be a food staple without any negative effects to development and growth. Many breeders use mealworms
                    because of the ease of use. Whichever food source you choose, be absolutely sure that to keep the
                    escaped
                    food to a minimum because both mealworms and crickets will eat the feces (poop) of the gecko and can
                    carry
                    parasites/ harmful bacteria as a result. Reptiles won't be aware that the escaped food is tainted and
                    will
                    eat them without a second thought. There are a few other "treats" you can give to your gecko like
                    waxworms,
                    phoenix worms, and horn worms. These treats should only be given on occassion but can be a good solution
                    to a gecko that is losing weight or not eating. Pinkies (day old mice) are a controversial food for
                    geckos
                    that some breeders will argue that they can provide good nutritional benefits to end of season breeding
                    females
                    while others will argue that the geckos have difficulty digesting the skeleton of the mouse.
                </p>
            </div>
            <div id="Vitamins" className="care-sheet-para">
                <h2>Vitamins</h2>
                <p> Much like people, geckos also require vitamins for good health, growth, and development. There are a few
                    options
                    to how you can give your gecko these vitamins. You can "gut-load" their food supply by feeding the
                    mealworms
                    / crickets a special food supply usually offered at pet stores or reptile shows. The other option is a
                    dust
                    that can be thrown on the cricket or mealworm this too can be bought at a pet store or reptile
                    show/expo.
                    It is recommended to leave some of this dust in the food dish or a small seperate dish as there are some
                    geckos who will eat the vitamins by itself.
                </p>
            </div>
            <div id="Cleaning" className="care-sheet-para">
                <h2>Cleaning</h2>
                <p> Due to the natural tendencies of leopard geckos, cleaning is a fairly simple process. Leopard geckos
                    usually
                    choose one corner to defecate in thus cleaning can be focused on that corner. Entire tank cleaning is
                    recommended
                    every couple of months. Just like the way a gecko's prey can carry the vitamins to the gecko through the
                    food eaten by mealworms and crickets, they can also give the gecko the bacteria and parasites that the
                    prey
                    has from eating the gecko's poop. For safe precautions mealworms that have escaped the food dish should
                    be
                    disposed of, and crickets should also be disposed of if they werent eaten in one meal.
                </p>
            </div>
        </React.Fragment >
    )
}
export const ReticulatedPythonCare = ({ setChapters, backToMenu }) => {
    useEffect(() => {
        setChapters(
            ['Housing', 'Heating', 'Substrate', 'Hides', 'Shedding', 'Feeding', 'Cleaning']
        )
    }, [])

    return (
        <React.Fragment>
            <ModuleTitle title="Reticulated Python Care" backToMenu={backToMenu} />
            <div id="Housing" className="care-sheet-para">
                <h2>Housing</h2>

                <p>
                    As with all snakes, Reticulated Pythons are great at escaping. Therefore, when caging your new pet you should make sure there aren't any holes where they can get through. Snakes are able to flatten themselves to squeeze through many tight spaces.
                    The most cost effective way to keep a Reticulated Python as pets is to purchase a 15-20 gallon tank, as a 10 gallon tank will be too small for an adult Reticulated Python but it is fine for a hatchling to young juvenile snake. Be sure that whatever choice you make for caging that there are venting areas in the tank to ensure good airflow, and avoiding stagnant air.
                    Snakes are NOT communal animals! It is not recommended to keep 2 or more snakes in the same cage (especially young ones) for an extended period of time. Reticulated Pythons may eat eachother and as a result both may die in the process. Because snakes refer to their sense of smell the most when it comes to deciding what is food or not, this is what is believed to cause this canabalism. While it is possible to keep Reticulated Pythons together granted that they are above 30" you may have issues with the snakes being stressed out.
                </p>
            </div>
            <div id="Heating" className="care-sheet-para">
                <h2>Heating</h2>
                <p>

                    Reticulated Pythons are instinctively nocturnal. That being said the best way to keep a Reticulated Python healthy is through undertank heating. Undertank heating is done through a adhesive pad that sticks to the bottom of the tank and plugs into an electrical socket. These pads are set to only reach a certain temperature, and can be left on continuously because the snake will move around where the temperature is comfortable for them. The pad should be placed on one end of the tank and only cover 1/4 to 1/3 of the tank's bottom to create a heat gradient so the snake can regulate it's body temperature. Although they are nocturnal they should have day/night cycles, this can be easily be achieved by being in a room with a window allowing mother nature to take care of it. If doesn't have windows you can simply leave a light on in the room during the day and turn it off at night.
                    The ideal temperature range for Reticulated Pythons is 80-85 F on the hot side. Just keep in mind that when using undertank heating, the temperature to check is on the ground and not the air. The ground temperature may achieve higher than the recommended levels, but Reticulated Pythons won't burn themselves if the heating pad is only on one side.

                </p>
            </div>
            <div id="Substrate" className="care-sheet-para">
                <h2>Substrate</h2>
                <p>
                    The choice of substrate is really a matter of personal preference. However, cedar and bark should not be used! Cedar is known to be toxic to snakes and can cause illness/death as a result. Sand and gravel should also be avoided due to the low absorbancy and increase in harmful bacteria growth, as well as being dangerous to the snake if ingested. Aspen bedding is the most popular choice for snake keepers as it is aesthetically pleasing, has a non-offensive smell and is quite absorbant. A cheaper alternative is to use newspaper sheets or paper towels, however the ink on the newspaper will transfer to the snake and temporarily make them appear darker due to the ink coating.
                </p>

            </div>

            <div id="Hides" className="care-sheet-para">
                <h2>Hides / Water (tank set up)</h2>
                <p>
                    Reticulated Pythons do occasionally climb but they will often be found on the bottom of the enclosure. That in mind there should be atleast 2 places to hide for your pet, one for the hot side and one for the cool side. Feel free to add any additional hides after that. A hide can consist of anything from a plastic container turned upside down, to a more aesthetic hide that you can find at pet stores. Be sure that the hide allows for the snake to be completley covered and is not see through, otherwise the snake will become stressed. As for water, a bowl that is large enough for your snake to completely lie inside of it. This will also help for shedding skin when the time comes. Not only is a large bowl recommended it is also requires less maintenance because it will retain the water much longer than a smaller one.
                </p>
            </div>
            <div id="Shedding" className="care-sheet-para">
                <h2> Shedding</h2>
                <p>
                    Shedding is an important process for reptiles, at this time the snake's entire outer skin becomes loose and eventually falls off. The outer layer of the snake's eyes will also come off giving them a "blue" color, this is where the term in the "blue" comes from. It is referring to the color of the eyes when the snake begins shedding. In most cases, Reticulated Pythons don't require much humidity during this time, but it doesn't hurt to spray the tank a little to help.
                </p>
            </div>
            <div id="Feeding" className="care-sheet-para">
                <h2>Feeding</h2>
                <p>
                    Feeding your Reticulated Python is a very simple process, and only needs to be done once a week. In the wild, Reticulated Pythons eat a variety of different prey items including insects, lizards, and rodents. In captivity, Reticulated Pythons only need to eat rats or mice. Whether you choose to feed your pet rats or mice it is important that they are captive kept. Feeding your snake wild caught prey increases the likelihood that your snake will get parasites or become ill and can lead to death.
                    Rodents can be fed to your snake either alive or frozen. Feeding live rodents runs the risk that the snake may be bit by the prey. Not only that but keeping live rodents will smell bad. Frozen prey allows you to buy in bulk and is the cheapest/easiest way to keep the food. Be sure to heat up the frozen mice until they are warm, very similar to a regular mouse's body heat. If the prey is too hot or too cold the snake will probably not eat it. Size of the prey is also an important factor, the general rule of thumb is to select mice/rats that are no wider than 2 times the width of the snake's widest body section, 1.5 times is recommended maximum size however.
                    While you can feed the snake inside it's cage, as a pet you may want to feed it in a seperate container or cardboard box. Otherwise, the snake may confuse your hands/fingers as it's prey and bite you instead. Feeding them outside the enclosure, trains the snake to recognize when it is feeding time or not based on it's surroundings.

                </p>
            </div>

            <div id="Cleaning" className="care-sheet-para">
                <h2>Cleaning</h2>
                <p>Cleaning should be done atleast every 2 months. Dirty cages are breeding grounds for unwanted bacteria, parasites and bugs. Make sure to remove all poop you find and wash the hides with soap.</p>
            </div>
        </React.Fragment >
    )
}
export const RedTailBoaCare = ({ setChapters, backToMenu }) => {
    useEffect(() => {
        setChapters(
            ['Housing', 'Heating', 'Substrate', 'Hides', 'Shedding', 'Feeding', 'Cleaning']
        )
    }, [])

    return (
        <React.Fragment>
            <ModuleTitle title="Red Tail Boa Care" backToMenu={backToMenu} />
            <div id="Housing" className="care-sheet-para">
                <h2>Housing</h2>

                <p>
                    As with all snakes, Red Tail Boas are great at escaping. Therefore, when caging your new pet you should make sure there aren't
                    any holes where they can get through. Snakes are able to flatten themselves to squeeze through many tight
                    spaces. The most cost effective way to keep a Red Tail Boa as pets is to purchase a 15-20 gallon tank, as a
                    10 gallon tank will be too small for an adult Red Tail Boa but it is fine for a hatchling to young juvenile
                    snake. Be sure that whatever choice you make for caging that there are venting areas in the tank to ensure
                    good airflow, and avoiding stagnant air. Snakes are NOT communal animals! It is not recommended to keep 2
                    or more snakes in the same cage (especially young ones) for an extended period of time. Red Tail Boas may
                    eat eachother and as a result both may die in the process. Because snakes refer to their sense of smell the
                    most when it comes to deciding what is food or not, this is what is believed to cause this canabalism. While
                    it is possible to keep Red Tail Boas together granted that they are above 30" you may have issues with the
                    snakes being stressed out.
                </p>
            </div>
            <div id="Heating" className="care-sheet-para">
                <h2>Heating</h2>
                <p>

                    Red Tail Boas are instinctively nocturnal. That being said the best way to keep a Red Tail Boa healthy is through undertank
                    heating. Undertank heating is done through a adhesive pad that sticks to the bottom of the tank and plugs
                    into an electrical socket. These pads are set to only reach a certain temperature, and can be left on continuously
                    because the snake will move around where the temperature is comfortable for them. The pad should be placed
                    on one end of the tank and only cover 1/4 to 1/3 of the tank's bottom to create a heat gradient so the snake
                    can regulate it's body temperature. Although they are nocturnal they should have day/night cycles, this can
                    be easily be achieved by being in a room with a window allowing mother nature to take care of it. If doesn't
                    have windows you can simply leave a light on in the room during the day and turn it off at night. The ideal
                    temperature range for Red Tail Boas is 80-85 F on the hot side. Just keep in mind that when using undertank
                    heating, the temperature to check is on the ground and not the air. The ground temperature may achieve higher
                    than the recommended levels, but Red Tail Boas won't burn themselves if the heating pad is only on one side.

                </p>
            </div>
            <div id="Substrate" className="care-sheet-para">
                <h2>Substrate</h2>
                <p>
                    The choice of substrate is really a matter of personal preference. However, cedar and bark should not be used! Cedar is known
                    to be toxic to snakes and can cause illness/death as a result. Sand and gravel should also be avoided due
                    to the low absorbancy and increase in harmful bacteria growth, as well as being dangerous to the snake if
                    ingested. Aspen bedding is the most popular choice for snake keepers as it is aesthetically pleasing, has
                    a non-offensive smell and is quite absorbant. A cheaper alternative is to use newspaper sheets or paper towels,
                    however the ink on the newspaper will transfer to the snake and temporarily make them appear darker due to
                    the ink coating.
                </p>

            </div>

            <div id="Hides" className="care-sheet-para">
                <h2>Hides / Water (tank set up)</h2>
                <p>
                    Red Tail Boas do occasionally climb but they will often be found on the bottom of the enclosure. That in mind there should
                    be atleast 2 places to hide for your pet, one for the hot side and one for the cool side. Feel free to add
                    any additional hides after that. A hide can consist of anything from a plastic container turned upside down,
                    to a more aesthetic hide that you can find at pet stores. Be sure that the hide allows for the snake to be
                    completley covered and is not see through, otherwise the snake will become stressed. As for water, a bowl
                    that is large enough for your snake to completely lie inside of it. This will also help for shedding skin
                    when the time comes. Not only is a large bowl recommended it is also requires less maintenance because it
                    will retain the water much longer than a smaller one.
                </p>
            </div>
            <div id="Shedding" className="care-sheet-para">
                <h2> Shedding</h2>
                <p>
                    Shedding is an important process for reptiles, at this time the snake's entire outer skin becomes loose and eventually falls
                    off. The outer layer of the snake's eyes will also come off giving them a "blue" color, this is where the
                    term in the "blue" comes from. It is referring to the color of the eyes when the snake begins shedding. In
                    most cases, Red Tail Boas don't require much humidity during this time, but it doesn't hurt to spray the
                    tank a little to help.
                </p>
            </div>
            <div id="Feeding" className="care-sheet-para">
                <h2>Feeding</h2>
                <p>
                    Feeding your Red Tail Boa is a very simple process, and only needs to be done once a week. In the wild, Red Tail Boas eat
                    a variety of different prey items including insects, lizards, and rodents. In captivity, Red Tail Boas only
                    need to eat rats or mice. Whether you choose to feed your pet rats or mice it is important that they are
                    captive kept. Feeding your snake wild caught prey increases the likelihood that your snake will get parasites
                    or become ill and can lead to death. Rodents can be fed to your snake either alive or frozen. Feeding live
                    rodents runs the risk that the snake may be bit by the prey. Not only that but keeping live rodents will
                    smell bad. Frozen prey allows you to buy in bulk and is the cheapest/easiest way to keep the food. Be sure
                    to heat up the frozen mice until they are warm, very similar to a regular mouse's body heat. If the prey
                    is too hot or too cold the snake will probably not eat it. Size of the prey is also an important factor,
                    the general rule of thumb is to select mice/rats that are no wider than 2 times the width of the snake's
                    widest body section, 1.5 times is recommended maximum size however. While you can feed the snake inside it's
                    cage, as a pet you may want to feed it in a seperate container or cardboard box. Otherwise, the snake may
                    confuse your hands/fingers as it's prey and bite you instead. Feeding them outside the enclosure, trains
                    the snake to recognize when it is feeding time or not based on it's surroundings.

                </p>
            </div>

            <div id="Cleaning" className="care-sheet-para">
                <h2>Cleaning</h2>
                <p>Cleaning should be done atleast every 2 months. Dirty cages are breeding grounds for unwanted bacteria, parasites
                    and bugs. Make sure to remove all poop you find and wash the hides with soap.</p>
            </div>

        </React.Fragment >
    )
}

export const BeardedDragonCare = ({ setChapters, backToMenu }) => {
    useEffect(() => {
        setChapters(
            ['Introduction', 'Housing', 'Heating', 'Substrate', 'Hides', 'Food', 'Vitamins']
        )
    }, [])

    return (
        <React.Fragment>
            <ModuleTitle title="Bearded Dragon Care" backToMenu={backToMenu} />
            <h5 className="text-light">Note: This caresheet was paraphrased and used with permission from the original writer
                at <a href="https://reptifiles.com">ReptiFiles.com</a> if you'd like more information check out their site!
            </h5>
            <div id="Introduction" className="care-sheet-para">
                <h2>Introduction</h2>
                <p>Bearded dragons (also known as the inland bearded dragon, central bearded dragon, or yellow-headed
                    bearded dragon) are agamid lizards native to eastern and central Australia. They can be found in a
                    variety of habitats, including semiarid desert, scrublands, and dry forests. They earned their name from
                    their spiky, expandable throat pouch that can look very much like a beard, especially when it darkens to
                    black.</p>

                <p>These lizards are diurnal, meaning that they are most active during the day. They love to bask, and are
                    commonly found sunbathing on everything from rocks and fallen branches to fenceposts and picnic tables.
                    Although they are technically terrestrial, bearded dragons are both excellent climbers and skilled
                    burrowers, and naturally dig burrows for shelter from predators and the elements. Since they are
                    diurnal, they also do their hunting during the day. Bearded dragons are omnivorous, so aside from
                    munching a variety of vegetation, they mostly prey upon insects, with the occasional small rodent or
                    lizard.</p>

                <p>Bearded dragons tend to be 18″-24″ (45-61 cm) long from snout to tail, weigh between 10-18 oz (283-511
                    g), and have a lifespan of 10-15+ years. They are usually sexually mature and fully grown at 1-2 years
                    old. They also possess a variety of adaptations that make them perfectly suited to their natural
                    environment:</p>
                <ul>
                    <li>Sticky tongue for grabbing insect prey, like a chameleon</li>
                    <li> Third (parietal) eye on top of their head for detecting predators
                    </li>
                    <li> Spiky scales—usually soft—can be tightened into a sharp spines for self-defense
                    </li>
                    <li> Can darken their color to absorb heat more efficiently
                    </li>
                    <li> Can inflate abdomen to facilitate floating in deep water
                    </li>
                </ul>
                <p>Their natural coloration is dull brown or tan with red or gold highlights, depending on local soil
                    color, but modern breeding practices have produced a variety of color morphs from white to lemon yellow
                    to dark red. Some breeders specialize in dragons with bright blue “tiger bars.” Modern breeding has also
                    produced different scale textures: Dunners (multidirectional scales), Leatherbacks (small, smooth
                    scales), and Silkbacks (no scales).</p>

                <p>Bearded dragons are exceptionally popular as pets, with a calm, curious temperament and array of social
                    behaviors that makes them a safe, entertaining first reptile. They have full-color vision and a keen
                    sense of smell that helps them recognize their keepers, and some people claim that their dragons respond
                    to their names. All bearded dragons available for sale outside of Australia are captive bred.</p>
            </div>
            <div id="Housing" className="care-sheet-para">
                <h2>Housing</h2>

                <p>
                    A bearded dragon terrarium needs to be big enough to provide enough space for exercise, as well as to
                    facilitate a proper temperature gradient. </p>

                <p>The absolute minimum appropriate enclosure size for a bearded dragon is 48″ x 24″ x 24″, or 120 x 60 x 60
                    cm.</p>

                <p>However, ReptiFiles strongly recommends that you go above and beyond these dimensions for housing your
                    pet. In fact, some sources argue that 5′ x 3′ x 3′ (150 x 90 x 90 cm) is a more suitable starting point!
                    Extra floor space and height allows your dragon to get more exercise, and demonstrate more natural
                    behaviors, which makes them more enjoyable for your to watch!</p>

                <p>Either way, you may have noticed that these recommendations are different from most sources. As we come
                    to understand reptile health better, it is becoming increasingly apparent that the majority of pet
                    reptiles are overweight due to overfeeding and lack of exercise. We at ReptiFiles strongly believe in
                    promoting a standard of care that puts reptiles’ needs first, so our numbers are different. Bigger is
                    always better, as long as you use the space well.
                </p>
            </div>
            <div id="Heating" className="care-sheet-para">
                <h2>Heating</h2>
                <p>
                    Like all reptiles, bearded dragons need heat to digest and maintain their immune systems. Without it,
                    they get sick and die. Since bearded dragons are basking lizards, they use heat most effectively from an
                    overhead heat source that mimics the sun. </p>

                <p>Since they are cold-blooded, bearded dragons need a temperature gradient in their enclosure in order to
                    be able to regulate their body temperature. Although they can tolerate very high basking temperatures,
                    they need to be able to escape to cooler areas in the enclosure to prevent overheating. For example, if
                    we were looking at an average enclosure from left to right, the highest temperatures should be at the
                    far left, gradually descending to the lowest temperatures on the far right.</p>
                <ul>
                    <li><b>Basking side surface temperature </b> — 108-113°F (42-45°C)</li>
                    <li><b>Cool side surface temperature</b> — 77-85°F (25-29°C)</li>
                    <li><b>Air temperature gradient</b> — 72-99°F (22-37°C)</li>
                    <li><b>Nighttime</b> — 55-75°F (12-24°C)</li>
                </ul>

                <p>The recommended basking surface temperature shown above is based on recommendations in Judish Badham’s
                    1971 PhD thesis, A comparison of two variants of the bearded dragon, Amphibolurus barbatus (Cuvier)
                    (since then verified by Dr. Jonathan Howard), where rectal temperatures of P. vitticeps were taken when
                    the dragons moved away from the sun, showing that they were done basking for the moment, and presumably
                    having reached optimal temperature. Their findings indicated that the optimum core body temperature of
                    central bearded dragons is 36.3°C (97.3°F), which requires basking site temperatures between 42-45°C
                    (108-113°F) to achieve. Dr. Howard’s basking substrate surface temperature measurements suggest that the
                    basking surface in a bearded dragon enclosure does not need to exceed 50°C (122°F), as this risks
                    overheating the enclosure.</p>

                <p>Surfaces like rocks and logs tend to collect heat over the course of the day, becoming significantly
                    warmer than the surrounding air (for example — have you ever burned yourself on a seat belt buckle even
                    though the air in your car wasn’t that hot?). According to a study by Jane Melville and James Schulte,
                    active body temperatures in Central Australian agamid lizards correlate closely with surface
                    temperatures, which means that measuring basking surface temperature is very important (more on how to
                    measure surface temperature later). For these reasons, a stone basking surface should be provided, as
                    this material is best at absorbing heat for bearded dragons to use.</p>

                <p>Additionally, most reptiles benefit from a nightly drop in temperature, which science suggests may
                    actually strengthen their immune system (rather than weaken it, as commonly believed). Provided that
                    daytime temperatures are correct, pet bearded dragons can handle nighttime drops as low as 50°F without
                    ill effect. In fact, providing cooler temperatures at night encourages beardies to bask in the morning,
                    which subsequently makes for a more active dragon. However, without adequate daytime warming, these cool
                    temperatures may induce brumation or illness.</p>

                <h6>How to Heat Your Bearded Dragon Enclosure</h6>

                <p>Use a high-wattage halogen bulb inside of a dome heat lamp with a ceramic socket to safely achieve the
                    right basking temperatures and thermal gradient. We recommend using a cluster of two Zoo Med Repti
                    Basking Spot or Philips 90w Equivalent PAR38 Halogen Flood bulbs for the most even heating.</p>

                <p>For an average 48″ x 24″ x 24″ enclosure, 90w should achieve the temperatures you need. If you need
                    hotter, raise the basking surface (preferably stone rather than plastic, mesh, or fabric) closer to the
                    heat source. If you need it to be a bit cooler (basking surface temperature over 130°F is too high), use
                    a lamp dimmer like the Lutron Credenza plug-in lamp dimmer to reduce heat output.</p>

            </div>
            <div id="Substrate" className="care-sheet-para">
                <h2>Substrate</h2>
                <p>
                    <h6>Best</h6>
                    <p>These substrates mimic a bearded dragon’s natural environment in Australia, making them the best. They
                        are burrowable, which means that your dragon can dig in a nice thick layer of these substrates to its
                        heart’s content. And although they are technically “loose” substrates, they do not pose an impaction
                        risk because they pack well and are composed of natural materials that bearded dragon’s digestive tracts
                        are built to handle. Pack the substrate 4-6″ deep for best results.</p>

                    <ul>
                        <li>Jurassic Natural Australian Desert Dragon Habitat — Actual Australian sand/soil harvested from
                            Central Australia. It doesn’t get more natural than this! Reasonably priced at $23 for 20 lbs.</li>
                        <li>Jurassic Reptile Substrate — Dust-free, soft, natural sand with a very fine texture. A little
                            expensive
                            ($40 for 25 lbs), but all-natural and does not cause impaction.</li>
                        <li>The BioDude Terra Sahara — Relatively expensive at about $50 for 36 quarts, but it’s bioactive-ready
                            and
                            lasts a long time.</li>
                        <li>DIY naturalistic mix — 50% play sand, 30% organic topsoil, 20% Zoo Med Excavator Clay. Very
                            inexpensive,
                            ingredients can be found at most home improvement stores (except for the clay). (NOT
                            bioactive-ready!)
                            Still not convinced that loose substrate is safe? In a 2017 study (A survey of diseases in captive
                            bearded dragons: a retrospective study of 529 patients by S. Schmidt-Ukaj et al.), despite most of
                            the
                            dragons having been housed on loose substrate, very few patients were impacted. Most of the few
                            impaction cases that there were already sick with other conditions such as parasite infestation and
                            MBD,
                            which were attributed as causing the impaction.</li>
                    </ul>

                    <h6>Better</h6>
                    <p>These substrates retain heat well and are more attractive. They also help keep your dragon’s nails filed
                        down and may offer burrowing value.</p>
                    <ul>
                        <li>Zoo Med Excavator Clay</li>
                        <li>Slate tile</li>
                    </ul>


                    <h6>Good</h6>
                    <p>These substrates are cheap, sterile, and make cleaning easy, but they’re better for quarantine than for
                        long-term housing.</p>
                    <ul>
                        <li>Paper towels</li>
                        <li>Newspaper</li>
                    </ul>


                    <h6>DO NOT USE:</h6>
                    <p>These substrates pose significant health risks to your bearded dragon!</p>

                    <ul>
                        <li><b>Calcium sand</b> — leads to impaction if ingested due to presence of calcium carbonate</li>
                        <li><b>Vitamin sand</b>— leads to impaction if ingested due to presence of calcium carbonate</li>
                        <li><b>Ground nut shell</b> — dusty and causes impaction if accidentally ingested</li>
                        <li><b>Wood products (bark, shavings, etc.)</b>— causes impaction if accidentally ingested</li>
                        <li><b>Linoleum</b> — produces VOCs</li>
                        <li><b>Shelf liner</b> — produces VOCs</li>
                        <li><b>Reptile carpet</b> — fibrous nature traps and breeds bacteria, can also catch claws and break
                            toes</li>
                    </ul>

                </p>

            </div>

            <div id="Hides" className="care-sheet-para">
                <h2>Hides / Water (tank set up)</h2>
                <p>As you create an indoor habitat for your bearded dragon, keep in mind that Pogona vitticeps is native to
                    eastern central Australia, where its habitat spans desert and grassland. That being said, there are so
                    many options when it comes to bearded dragon decorations. Some people (like myself) prefer to respect
                    the bearded dragon’s origins with desert theme. Others prefer a more tropical look. And still others
                    like to turn their beardie’s home into something of a dollhouse. *shrug* The most important thing for
                    you to do is</p>
                <ul>
                    <li>make sure it can accommodate a bearded dragon’s temperature, UV, and humidity requirements</li>
                    <li>make sure it’s dragon-safe</li>
                    <li>decorate it appropriate for your dragon’s exercise and spacial needs</li>
                    <li>choose furnishings that fit your taste</li>
                </ul>

                <h6>Basking Rock/Log</h6>
                <p>This is one of the bearded dragon decorations you can’t go without, because it helps your beardie find
                    the perfect basking temperature. Bearded dragons also like to climb for exercise, so providing a basking
                    fixture is perfect. Personally I really like using a cork bark log for this.
                </p>
                <h6>Hide/Burrow/Cave</h6>
                <p>
                    Bearded dragons need a place to hide out when they want to be left alone. They use their hide when they
                    want to escape the heat, are looking for some extra humidity, are brumating, or simply want a protected
                    place to take a nap.
                </p>
                <p>
                    Another reason I like cork bark logs is that they can double as a hide and a basking platform.

                </p>

                <h6>Hammock</h6>
                <p>
                    Bearded dragons have a strange but compelling love for hammocks, likely because they like to climb and
                    get up high to survey the surrounding terrain. Because hammocks don’t retain much heat, it’s best not to
                    use them as a basking platform. But they still make great places for your dragon to just hang out on the
                    cooler end of the enclosure.

                </p>

                <h6>Bones</h6>
                <p>
                    Yes, bones. The man we bought our bearded dragons from used sterilized, dry cow bones he found in the
                    wilderness to decorate his terrarium, and let me tell you—it looked cool.

                </p>
                <h6>Flagstone</h6>
                <p>
                    Flagstone is a cheap, natural material with a plethora of uses in your dragon’s enclosure. Its rough
                    texture makes it excellent for keeping claws filed down without inhibiting climbing ability. It also
                    absorbs heat very well, making a perfect basking area when placed under the heat lamp. A word of
                    caution, though: flagstone is heavy and large pieces can be difficult to handle.
                </p>
            </div>

            <div id="Food" className="care-sheet-para">
                <h2>Food</h2>
                <h6>Vegetables</h6>
                <p>Even hatchling bearded dragons should be offered a salad of nutritious greens and vegetables every day.
                    While they may not lick the bowl clean, it’s best to offer some for snacking, and that will make the
                    transition to a main diet of vegetables later on easier. Since bearded dragons are omnivores like
                    humans,
                    they need a variety. Feeding a variety of veggies gives your dragon a good balance of the nutrients s/he
                    needs to keep bones healthy and immune system going strong. Fortunately, the list of dragon-safe
                    vegetables
                    is a long one.</p>

                <h6>Staples:</h6>
                <ul>
                    <li>Arugula/Rocket</li>
                    <li>Bok choy</li>
                    <li>Cactus pads</li>
                    <li>Collard greens/Spring greens</li>
                    <li>Endive/Chicory</li>
                    <li>Escarole</li>
                    <li>Kale*</li>
                    <li>Mustard greens</li>
                    <li>Mustard cress</li>
                    <li>Pea shoots</li>
                    <li>Spring mix</li>
                    <li>Turnip greens</li>
                    <li>Watercress</li>
                </ul>

                <p>*There is a common myth that kale is high in oxalates and as bad as spinach. However, according to
                    multiple
                    studies, kale is quite low in oxalates, and is recommended by kidney health experts as a “safe” green
                    for
                    those prone to kidney stones. So although all things must be fed in a rotation, kale is quite safe to be
                    offered regularly.</p>

                <h6>Mixers (to be fed occasionally):</h6>

                <ul>
                    <li>Artichoke heart</li>
                    <li>Asparagus</li>
                    <li>Basil</li>
                    <li>Beet leaves</li>
                    <li>Bell pepper</li>
                    <li>Carnations</li>
                    <li>Cilantro</li>
                    <li>Carrot greens</li>
                    <li>Cucumber, peeled</li>
                    <li>Carrot, grated raw</li>
                    <li>Clover (pesticide- and herbicide-free)</li>
                    <li>Dandelion greens/flowers</li>
                    <li>Fennel</li>
                    <li>Lemon balm</li>
                    <li>Lemongrass</li>
                    <li>Mint leaves</li>
                    <li>Nasturtium</li>
                    <li>Pansies</li>
                    <li>Parsley</li>
                    <li>Radicchio</li>
                    <li>Rosemary</li>
                    <li>Rose petals</li>
                    <li>Spinach (valuable source of iodine!!)</li>
                    <li>Squash, raw</li>
                    <li>Sugar snap peas</li>
                    <li>Swiss chard</li>
                    <li>Thyme</li>
                    <li>Yam, grated raw</li>
                    <li>Zucchini</li>
                </ul>

                <h6>Poison:</h6>
                <ul>
                    <li>Avocado</li>
                    <li>Onion</li>
                    <li>Mushrooms</li>
                </ul>

                <p>Vegetables should be sliced into thin, bite-sized pieces than your beardie can grab with his/her tongue.
                    Wet
                    or slimy vegetables like cucumber and cactus may frustrate your dragon since these don’t stick to
                    tongues
                    very well. You can hand-feed these to him/her, but your dragon may accidentally bite you in the effort
                    to
                    get it.</p>

                <p>Wild plants and flowers (aka “weeds”) can add some highly beneficial variety to your dragon’s diet (after
                    a
                    thorough washing, of course). However, not all found plants and flowers are safe for feeding, and some
                    are
                    deadly. So if you’re unfamiliar with the plants in your area or you’re in a highly urban area, it’s good
                    to
                    grow your own “wild” plants for your dragon to munch on even if all you have is a window box. Arizona
                    Tortoise Compound and ProRep both offer excellent seed mixes for a very reasonable price. Use organic
                    potting soil and no pesticides for optimally edible results.</p>

                <h6>Fruits</h6>
                <p>Up to 10% of your beardie’s diet may consist of fruit. Fruits tend to have a higher water content and
                    more
                    sugar than vegetables, so they must be fed sparingly to prevent a laxative effect or obesity. They make
                    excellent treats, however. My Nabooru went wild for cantaloupe.</p>

                <h6>Staples:</h6>
                <ul>
                    <li>cactus fruit (aka prickly pear)</li>
                </ul>
                <h6> Mixers (to be fed occasionally): </h6>
                <ul>
                    <li>Mango</li>
                    <li>Banana</li>
                    <li>Melon</li>
                    <li>Berries</li>
                    <li>Grapes</li>
                    <li>Figs</li>
                    <li>Papaya</li>
                    <li>Peaches</li>
                    <li>Apples</li>
                </ul>

                <h6>Poison:</h6>
                <ul>
                    <li>citrus</li>
                    <li>rhubarb</li>
                </ul>
                <p>For an extensive list of bearded dragon vegetables, fruits, and associated nutrition facts, please visit
                    Beautiful Dragons’ Nutrition page. This is a good resource to keep saved on your phone for reference
                    while
                    you’re at the grocery store.</p>

                <h6>Protein</h6>
                <p>When choosing bearded dragon bugs, make sure that they are no bigger than the space between your dragon’s
                    eyes. This rule can be bent for insects such as superworms and hornworms, but is extremely important for
                    roaches, crickets, and pinky mice.</p>

                <h6>Good feeder insects include:</h6>
                <ul>
                    <li>Black soldier fly larvae (phoenix worms)</li>
                    <li>Crickets</li>
                    <li>Dubia roaches</li>
                    <li>Discoid roaches</li>
                    <li>Red runner roaches</li>
                    <li>Hornworms (captive only; wild are toxic!)</li>
                    <li>Silkworms</li>
                    <li>Snails</li>
                    <li>Repashy Grub Pie gel mix</li>
                </ul>

                <p>All feeder insects should be gutloaded for at least 24 hours before feeding to your bearded dragon.
                    Ideally,
                    they should come pre-gutloaded from the breeder. If they weren’t, or you buy your feeder insects in
                    bulk,
                    the easiest way to keep them fed and gut-loaded is with a rotation of Lugarti Dubia Diet and Grassland
                    Grazer.</p>

                <p>Every once in a while, you can give your dragon a nice, high-fat treat. Your dragon will become obese if
                    fed
                    these too often, but hey, that’s why they’re called treats.</p>

                <h6>Treats:</h6>
                <ul>
                    <li>Superworms</li>
                    <li>Butterworms</li>
                    <li>Waxworms</li>
                    <li>Pinky mice (no more than 1x/month)</li>
                </ul>

                <p>Beware of feeding your dragon wild-caught bugs! These may be coated in poisonous pesticide/herbicide, or
                    may
                    be naturally toxic. If you choose to collect wild-caught bugs, this article is a helpful resource on how
                    to
                    do so safely. BeardedDragon.org has a very helpful chart of insects are are toxic for beardies to
                    ingest.
                    Not listed, however, are box elder bugs, which are also toxic.</p>

            </div>
            <div id="Vitamins" className="care-sheet-para">
                <h2>Supplements</h2>
                <p>
                    To ensure that your beardie is getting all the vitamins and minerals they need, you need to keep two
                    forms of supplementation on hand: calcium powder and multivitamin powder. Take care not to use these too
                    often; over-supplementation can be just as deadly as under-supplementation.</p>

                <h6>How to use supplements</h6>
                <p>Generously dust feeder insects before feeding. Most people prefer the “shake-and-bake” method of
                    dusting, where you stick all the bugs in a bag or disposable plastic container and shake them until they
                    are evenly coated in powder. Calcium sticks better to some bugs than others, and if you’re feeding black
                    soldier fly larvae, you don’t need to dust them at all, as they are naturally high in calcium.</p>

                <p>The following are supplements and supplement combos that ReptiFiles recommends for use with bearded
                    dragons:</p>
                <ul>
                    <li>Arcadia Earthpro A + Arcadia RevitaliseD3</li>
                    <li>Miner-All Outdoor + Repashy Supervite</li>
                    <li>Repashy Calcium Plus LoD</li>
                    <li>Miner-All Indoor + Herptivite</li>
                </ul>

                <p>Use each supplement as directed by the label.</p>

                <p>It is alright to occasionally skip a dusting (once every 3-4 feedings) so your bearded dragon’s system
                    doesn’t become overloaded with calcium.</p>
            </div>
        </React.Fragment >
    )
}